export class TituloReceberResumo {
	// Total
    quantidadeTotal: number;           // Quantidade Total: Soma da quantidade de todos os títulos
    valorTotal: number;                // Valor Total: Soma do valor de todos os títulos
    quantidadeDiasVencimentos: number; // Quantidade total de dias de todos os títulos com base na data de emissão até a data de vencimento
    prazoMedioVencimento: number;      // Prazo médio de vencimento com base na quantidade de dias de todos os títulos dividido pela quantidade de todos os títulos
	// Pago
    quantidadePago: number;                   // Quantidade Pago: Soma da quantidade de todos os títulos pagos
    valorPago: number;                        // Valor Pago: Soma do valor de todos os títulos pagos
    quantidadeDiasPagamentosEmAtraso: number; // Quantidade total de dias em atrasos dos títulos pagos
    quantidadeDiasPagamentos: number; // Quantidade total de dias dos títulos pagos com base na data de emissão até a data de pagamento
    prazoMedioPagamento: number; // Prazo médio de pagamento com base na quantidade de dias de pagamentos divido pela quantidade de títulos pagos
    mediaPagamentoEmAtraso: number; // Média de Pagamento em Atraso: Somar a quantidade de dias em atraso (apenas os títulos que foram pagos), dividir pela quantidade de títulos pagos.
	// Em Aberto
    quantidadeAberto: number; // Quantidade Aberto: Soma da quantidade de todos os títulos abertos
    valorAberto: number; // Valor Aberto: Soma do valor em aberto dos títulos
    quantidadeDiasEmAberto: number; // Quantidade total de dias dos títulos em aberto com base na data de emissão até data de vencimento
    prazoMedioEmAberto: number; // Prazo médio em aberto com base na quantidade de dias em aberto divido pela quantidade de títulos em aberto
	// Vencido
    quantidadeVencido: number; // Quantidade Vencido: Soma da quantidade de todos os títulos vencidos
    valorVencido: number; // Valor Vencido: Soma do valor em aberto vencido

    maiorAtraso: number; // Colocar em dias qual foi o título pago com o maior atraso. Ver se há título vencido.

    constructor() {
        // Total
        this.quantidadeTotal = 0;
        this.valorTotal = 0;
        this.quantidadeDiasVencimentos = 0;
        this.prazoMedioVencimento = 0;
        // Pago
        this.quantidadePago = 0;
        this.valorPago = 0;
        this.quantidadeDiasPagamentosEmAtraso = 0;
        this.quantidadeDiasPagamentos = 0;
        this.prazoMedioPagamento = 0;
        this.mediaPagamentoEmAtraso = 0;
        // Em Aberto
        this.quantidadeAberto = 0;
        this.valorAberto = 0;
        this.quantidadeDiasEmAberto = 0;
        this.prazoMedioEmAberto = 0;
        // Vencido
        this.quantidadeVencido = 0;
        this.valorVencido = 0;

        this.maiorAtraso = 0;
    }
}
